import cookie from 'cookie';
import { type CookieValueTypes, getCookie, setCookie } from 'cookies-next';

import { i18nConfig } from '../constants';

import { getIsLocaleAcceptable } from './check-locale-validity';

/**
 * Should be used on the client to set the `locale` cookie in the browser
 */
export const setLocaleToCookie = (
  locale: string,
  fallbackLocale = i18nConfig.defaultLocale,
  acceptableLocalesList = i18nConfig.locales,
) => {
  const isLocaleAcceptable = getIsLocaleAcceptable(locale, acceptableLocalesList);
  const localeCookieValue = isLocaleAcceptable ? locale : fallbackLocale;

  if (isLocaleAcceptable === false) {
    console.warn(`Provided locale: "${locale}" is not valid and the cookie will not be set with this value`);
    return false;
  }

  setCookie(i18nConfig.localeCookie, localeCookieValue, i18nConfig.cookieOptions);

  return true;
};

/**
 * Should be used on the client to get the `locale` cookie from the browser
 */
export const getLocaleFromCookie = () => {
  return getCookie(i18nConfig.localeCookie, i18nConfig.cookieOptions);
};

/**
 * Can be used in "Server Components" or during SSR to get the `locale` cookie from the incoming Request headers
 */
export const getLocaleFromRequestCookieHeaders = (headers: Headers): CookieValueTypes => {
  const cookies = cookie.parse(headers.get('Cookie') ?? '');
  return cookies[i18nConfig.localeCookie];
};
